import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.total;

export default class Total extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      total: this.number(0),
    };
  }
}
